import { httpRequest } from "@/utils/HttpRequest";
import { IPage } from "@/types/AppTypes";
import { Key } from "react";


/***************************fms************************* */
interface ITreeDs<T> {
    enable?: number;
    code?: string;
    children?: T[]
}

export interface ITreeData<T> {
    key: Key;
    title?: string;
    children?: ITreeData<T>[] | undefined;
}

export interface IFieldValue<T> {
    [key: string]: T[keyof T]
}


export function trasDsToTreeData<T extends ITreeDs<T>>(
    ds: T[],
    keyField: keyof T,
    titleField: keyof T,
): ITreeData<T>[] {
    return ds.map(el => {
        const key = el[keyField] as any;
        const title = el[titleField] as any;
        const children = el.children && el.children.length > 0 ? trasDsToTreeData(el.children, keyField, titleField) : undefined;
        const disabled = el.enable === 0;
        return {
            el,
            key,
            title,
            disabled,
            value: el["code"],
            selectable: !disabled,
            children,
        }
    });
}
/*********************************************************************************** */

export interface IDictSearch {
    page: {
        pageSize: number;
        pageNum: number;
    }
    sourceApp?: string;
}

export interface IDictDetail {
    note: string,
    ver: number,
    code: string,
    sourceAuthKey?: string,
    pcode: string | null,
    children: IDictDetail[],
    enable: number,
    name: string,
    nameEn?: string,
    branch?: string,
    value: string,
    key: string,
    status?:number
}

export interface IDictInsert {
    sourceApp?: string,
    branch?: string,
    code: string,
    name: string,
    value?: string,
    pcode?: string | null,
    note?: string,
}
export interface IDictUpdate {
    sourceApp?: string,
    branch?: string,
    code: string,
    value?: string,
}

export interface IDictOne {
    sourceApp?: string,
    branch?: string,
    code: string
}

export interface IDictSync {
    sourceApp?: string,
    branch?: string,
    branchList?: string[]
}

class DictService {
    //树列表
    async page(searchVo: IDictSearch) {
        const apiUrl = "/gtm/base/dict/page";
        return await httpRequest.post<IPage<IDictDetail>>(apiUrl, searchVo)
    }
    //新增
    async insert(insertVo: IDictInsert) {
        const apiUrl = "/gtm/base/dict/insert";
        return await httpRequest.post<boolean>(apiUrl, insertVo);
    }
    //编辑
    async update(updateVo: IDictUpdate) {
        const apiUrl = "/gtm/base/dict/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo)
    }
    //获取一条
    async one(oneVo: IDictOne) {
        const apiUrl = "/gtm/base/dict/one";
        return await httpRequest.post<IDictDetail>(apiUrl, oneVo)
    }

    async disable(oneVo: IDictOne) {
        const apiUrl = "/gtm/base/dict/disable";
        return await httpRequest.post<boolean>(apiUrl, oneVo)
    }

    async remove(oneVo: IDictOne) {
        const apiUrl = "/gtm/base/dict/remove";
        return await httpRequest.post<boolean>(apiUrl, oneVo)
    }
    async sync(obj: IDictSync) {
        const apiUrl = "/gtm/base/dict/sync";
        return await httpRequest.post<boolean>(apiUrl, obj)
    }
}

export const dictService = new DictService();
